import { ButtonProps, forwardRef } from '@chakra-ui/react'

import { SolidActionButton } from './ActionButton'

export const BigGreenButton = forwardRef<ButtonProps, 'button'>((props: ButtonProps, ref) => (
  <SolidActionButton
    ref={ref}
    mx="auto"
    height="auto"
    py={[3, 4]}
    px={[4, 5]}
    borderRadius={32}
    boxShadow="md"
    fontWeight={500}
    fontSize="xl"
    fontFamily="hero-new"
    {...props}
  />
))
